import { useCallback, useReducer } from 'react';
import { createSessionTimeline, reduceSessionTimeline, type SessionTimelineAction, type SessionTimelineState } from '../../shared/session-engine';

export function useSessionTimeline(initialSessionKey = 'loading') {
  const [state, dispatch] = useReducer(reduceSessionTimeline, initialSessionKey, createSessionTimeline);
  const send = useCallback((action: SessionTimelineAction) => dispatch(action), []);
  return { ...state, dispatch: send };
}
